import { useQuery } from '@tanstack/react-query';
import { useTokenProvider, useConfig, useLogger } from '@gplibraries/react/hooks';
import { fetchB2BDomains } from '@gplibraries/react/api';
/**
 * Fetch dealer B2B domains.
 */
export function useB2BDomains() {
    const logger = useLogger();
    const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
    const getToken = useTokenProvider({ scopes: [dealerAccessApiScope] });
    const { isLoading, error, data } = useQuery({
        enabled: Boolean(getToken),
        queryKey: ['b2bDomains'],
        queryFn: () => getToken()
            .then(token => fetchB2BDomains(dealerAccessApiHost, token.accessToken))
            .then(res => res.json()),
        select: result => result.data ?? null
    });
    if (error) {
        logger.error(error, {
            source: 'useB2BDomains',
        });
    }
    return {
        data: data ?? null,
        loading: isLoading,
        error
    };
}
